<template>
  <div class="main">
    <c-panel title="Ficha do leitor" titleIcon="fas fa-id-card">
      <!--
        Item 13 do edital: "cadastrar os leitores da biblioteca, permitindo informar o nome da
        pessoa, CPF, RG, data de nascimento, naturalidade, telefone e e-mail."

        NÃO existe cadastro de leitor. O leitor é SELECIONADO entre pessoas que já existem na
        rede, e os sete dados vêm da origem — somente leitura. Corrigir CPF é na ficha do
        aluno, com a secretaria; não no balcão da biblioteca.
      -->
      <el-row :gutter="10" class="u-mb-15">
        <el-col :xs="24" :sm="14">
          <el-select v-model="selecionado" filterable remote clearable
                     :remote-method="buscarLeitor" :loading="buscando"
                     placeholder="Digite o nome do aluno ou servidor" style="width:100%"
                     @change="carregarFicha">
            <el-option v-for="l in opcoes" :key="l.tipo + '-' + l.id"
                       :label="l.label" :value="l.tipo + '-' + l.id"></el-option>
          </el-select>
          <small class="u-text-muted">A busca alcança apenas pessoas da sua instituição.</small>
        </el-col>
      </el-row>

      <div v-if="ficha">
        <el-alert v-if="situacaoTipo === 'suspenso'" type="error" show-icon :closable="false" class="u-mb-15"
                  :title="'Leitor SUSPENSO — ' + (ficha.situacao.motivo || '')"
                  :description="ficha.situacao.ate ? ('Até ' + formatarData(ficha.situacao.ate)) : 'Por tempo indeterminado'">
        </el-alert>
        <el-alert v-else-if="situacaoTipo === 'inativo'" type="warning" show-icon :closable="false" class="u-mb-15"
                  title="Leitor sem vínculo ativo"
                  description="Sem matrícula ativa (aluno) ou sem lotação (servidor).">
        </el-alert>
        <el-alert v-else type="success" show-icon :closable="false" class="u-mb-15" title="Leitor ativo"></el-alert>

        <el-tabs v-model="aba">
          <!-- ============ Dados pessoais — item 13 ============ -->
          <el-tab-pane label="Dados" name="dados">
            <el-alert type="info" :closable="false" show-icon class="u-mb-15"
                      title="Estes dados vêm do cadastro de origem e são somente leitura"
                      description="Para corrigir, edite a ficha do aluno ou do servidor.">
            </el-alert>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12"><div class="campo"><label>Nome</label><span>{{ ficha.leitor.nome || '—' }}</span></div></el-col>
              <el-col :xs="24" :sm="6"><div class="campo"><label>CPF</label><span>{{ ficha.leitor.cpf || '—' }}</span></div></el-col>
              <el-col :xs="24" :sm="6"><div class="campo"><label>RG</label><span>{{ rgCompleto }}</span></div></el-col>
              <el-col :xs="24" :sm="6"><div class="campo"><label>Data de nascimento</label><span>{{ formatarData(ficha.leitor.data_nascimento) }}</span></div></el-col>
              <el-col :xs="24" :sm="6"><div class="campo"><label>Naturalidade</label><span>{{ ficha.leitor.naturalidade || '—' }}</span></div></el-col>
              <el-col :xs="24" :sm="6"><div class="campo"><label>Telefone</label><span>{{ ficha.leitor.telefone || ficha.leitor.celular || '—' }}</span></div></el-col>
              <el-col :xs="24" :sm="6">
                <div class="campo">
                  <label>E-mail</label>
                  <!-- Sem e-mail é ausência de dado, não string vazia. -->
                  <span>{{ ficha.leitor.email || '— não informado' }}</span>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>

          <!-- ============ Dependentes — item 14 ============ -->
          <el-tab-pane :label="'Dependentes (' + (ficha.dependentes || []).length + ')'" name="dependentes">
            <el-alert type="info" :closable="false" show-icon class="u-mb-15"
                      title="O dependente é uma pessoa já cadastrada na rede"
                      description="Nenhum dado pessoal é copiado: nome, CPF, RG e demais campos são lidos do cadastro de origem.">
            </el-alert>

            <el-row :gutter="10" class="u-mb-15" v-if="podeOperar">
              <el-col :xs="24" :sm="10">
                <el-select v-model="novoDep.pessoa" filterable remote clearable
                           :remote-method="buscarDependente" :loading="buscandoDep"
                           placeholder="Pessoa da rede" style="width:100%">
                  <el-option v-for="l in opcoesDep" :key="'d'+l.tipo+'-'+l.id"
                             :label="l.label" :value="l.tipo + '-' + l.id"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="24" :sm="6">
                <el-select v-model="novoDep.parentesco" placeholder="Parentesco" style="width:100%">
                  <el-option v-for="p in parentescos" :key="p" :label="p.toUpperCase()" :value="p"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-button type="primary" icon="el-icon-plus" @click="vincularDependente"
                           :disabled="!novoDep.pessoa || !novoDep.parentesco">VINCULAR</el-button>
              </el-col>
            </el-row>

            <table class="table table-striped">
              <thead>
                <tr><th>Nome</th><th style="width:130px;">Parentesco</th><th class="hidden-mobile" style="width:140px;">CPF</th>
                    <th style="width:100px;" class="u-text-center">Ativo</th>
                    <th style="width:110px;" class="u-text-center" v-if="podeOperar">Ação</th></tr>
              </thead>
              <tbody>
                <tr v-for="d in (ficha.dependentes || [])" :key="d.id">
                  <td>{{ d.pessoa ? d.pessoa.nome : '(fora do seu escopo)' }}</td>
                  <td>{{ (d.parentesco || '').toUpperCase() }}</td>
                  <td class="hidden-mobile">{{ d.pessoa ? (d.pessoa.cpf || '—') : '—' }}</td>
                  <td class="u-text-center">{{ d.situacao ? 'SIM' : 'NÃO' }}</td>
                  <td class="u-text-center" v-if="podeOperar">
                    <el-button v-if="d.situacao" @click="desvincular(d)" title="Desvincular"
                               type="warning" icon="el-icon-close" size="mini" plain></el-button>
                    <span v-else class="u-fs-12">—</span>
                  </td>
                </tr>
                <tr v-if="(ficha.dependentes || []).length === 0">
                  <td :colspan="podeOperar ? 5 : 4" class="u-text-center">Nenhum dependente vinculado.</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>

          <!-- ============ Empréstimos em aberto ============ -->
          <el-tab-pane :label="'Em aberto (' + (ficha.emprestimos_abertos || []).length + ')'" name="emprestimos">
            <table class="table table-striped">
              <thead>
                <tr><th>Título</th><th style="width:120px;">Exemplar</th>
                    <th style="width:160px;">Retirada</th><th style="width:140px;">Devolver até</th>
                    <th style="width:110px;" class="u-text-center">Situação</th></tr>
              </thead>
              <tbody>
                <tr v-for="e in (ficha.emprestimos_abertos || [])" :key="e.id">
                  <td>{{ e.titulo }}</td>
                  <td>{{ e.codigo }}</td>
                  <td>{{ formatarDataHora(e.data_emprestimo) }}</td>
                  <td>{{ formatarData(e.data_prevista_devolucao) }}</td>
                  <td class="u-text-center">
                    <el-tag v-if="e.em_atraso" type="danger" size="mini">EM ATRASO</el-tag>
                    <el-tag v-else type="success" size="mini">no prazo</el-tag>
                  </td>
                </tr>
                <tr v-if="(ficha.emprestimos_abertos || []).length === 0">
                  <td colspan="5" class="u-text-center">Nenhum empréstimo em aberto.</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>

          <!-- ============ Suspensões — itens 15 e 16 ============ -->
          <el-tab-pane :label="'Suspensões (' + (ficha.suspensoes || []).length + ')'" name="suspensoes">
            <el-button v-if="podeSuspender && situacaoTipo !== 'suspenso'" type="danger" plain
                       icon="el-icon-remove-outline" class="u-mb-15" @click="abrirSuspensao">
              SUSPENDER ESTE LEITOR
            </el-button>

            <table class="table table-striped">
              <thead>
                <tr><th style="width:110px;">Início</th><th style="width:110px;">Fim</th>
                    <th>Motivo</th><th class="hidden-mobile">Instituição</th>
                    <th style="width:110px;" class="u-text-center">Situação</th>
                    <th style="width:110px;" class="u-text-center" v-if="podeSuspender">Ação</th></tr>
              </thead>
              <tbody>
                <tr v-for="s in (ficha.suspensoes || [])" :key="s.id">
                  <td>{{ formatarData(s.data_inicio) }}</td>
                  <td>{{ s.data_fim ? formatarData(s.data_fim) : 'indeterminado' }}</td>
                  <td>{{ s.motivo }}</td>
                  <td class="hidden-mobile">{{ s.instituicao_id }}</td>
                  <td class="u-text-center">
                    <el-tag v-if="s.data_revogacao" type="info" size="mini">revogada</el-tag>
                    <el-tag v-else-if="s.vigente" type="danger" size="mini">vigente</el-tag>
                    <el-tag v-else type="warning" size="mini">encerrada</el-tag>
                  </td>
                  <td class="u-text-center" v-if="podeSuspender">
                    <el-button v-if="!s.data_revogacao && s.vigente" @click="abrirRevogacao(s)"
                               title="Desfazer suspensão" type="success" icon="el-icon-refresh-left"
                               size="mini" plain></el-button>
                    <span v-else class="u-fs-12">—</span>
                  </td>
                </tr>
                <tr v-if="(ficha.suspensoes || []).length === 0">
                  <td :colspan="podeSuspender ? 6 : 5" class="u-text-center">Nenhuma suspensão registrada.</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
        </el-tabs>
      </div>

      <el-alert v-else-if="selecionado" type="info" :closable="false" show-icon
                title="Não foi possível carregar a ficha deste leitor."></el-alert>

      <!-- ============ Diálogo: suspender (item 15) ============ -->
      <el-dialog title="Suspender leitor" :visible.sync="dialogSuspender" width="560px" append-to-body>
        <el-form label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12">
              <el-form-item label="Início *">
                <el-date-picker v-model="formSusp.data_inicio" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="Fim (em branco = indeterminado)">
                <el-date-picker v-model="formSusp.data_fim" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24">
              <el-form-item label="Motivo *">
                <el-input v-model="formSusp.motivo" maxlength="191"
                          placeholder="Por que este leitor está sendo suspenso"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogSuspender = false">CANCELAR</el-button>
          <el-button class="u-ml-10" type="danger" @click="suspender" :loading="salvando">SUSPENDER</el-button>
        </span>
      </el-dialog>

      <!-- ============ Diálogo: revogar (item 16) ============ -->
      <el-dialog title="Desfazer suspensão" :visible.sync="dialogRevogar" width="520px" append-to-body>
        <el-alert type="info" :closable="false" show-icon class="u-mb-15"
                  title="A suspensão não é apagada"
                  description="Ela fica registrada como revogada, com a data e o motivo — o histórico da decisão é preservado.">
        </el-alert>
        <el-form label-position="top">
          <el-form-item label="Motivo da revogação *">
            <el-input v-model="formRev.motivo_revogacao" maxlength="191"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogRevogar = false">CANCELAR</el-button>
          <el-button class="u-ml-10" type="success" @click="revogar" :loading="salvando">DESFAZER SUSPENSÃO</el-button>
        </span>
      </el-dialog>
    </c-panel>
  </div>
</template>

<script>
export default {
  components: { cPanel: () => import('@/shared/c-panel/c-panel.vue') },

  data: () => ({
    aba: 'dados',
    buscando: false, buscandoDep: false, salvando: false,
    opcoes: [], opcoesDep: [],
    selecionado: '',
    ficha: null,
    parentescos: [],
    novoDep: { pessoa: '', parentesco: '' },
    dialogSuspender: false, dialogRevogar: false,
    formSusp: {}, formRev: {}, suspensaoAlvo: null
  }),

  computed: {
    // Espelho da matriz do backend; o Service é quem decide de fato.
    podeOperar () { return [0, 1, 4, 5, 12].indexOf(Number(this.$store.state.user.tipo)) !== -1 },
    podeSuspender () { return this.podeOperar },
    base () { return `${this.$store.state.config.baseUrlApi}/api/biblioteca` },
    situacaoTipo () { return this.ficha && this.ficha.situacao ? this.ficha.situacao.situacao : '' },
    rgCompleto () {
      if (!this.ficha || !this.ficha.leitor.rg) return '—'
      const l = this.ficha.leitor
      return l.rg + (l.orgao_emissor_rg ? ' ' + l.orgao_emissor_rg : '') + (l.uf_rg ? '/' + l.uf_rg : '')
    },
    tipoId () {
      if (!this.selecionado) return null
      const p = this.selecionado.split('-')
      return { tipo: p[0], id: p[1] }
    },
    instituicaoAtual () {
      const i = this.$store.state.config.instituicao
      return i ? i.id : null
    }
  },

  mounted () { this.carregarParentescos() },

  methods: {
    formatarData (d) { return d ? this.$moment(d).format('DD/MM/YYYY') : '—' },

    /** Empréstimo anterior ao Bloco Y não tem hora: não se inventa uma. */
    formatarDataHora (d) {
      if (!d) return '—'
      const m = this.$moment(d)
      return m.format('HH:mm:ss') === '00:00:00'
        ? m.format('DD/MM/YYYY') + ' (hora não registrada)'
        : m.format('DD/MM/YYYY HH:mm')
    },

    carregarParentescos () {
      this.$axios.get(`${this.base}/dependente/parentescos`, this.$store.getters.getHeaderAuth)
        .then(r => { this.parentescos = Array.isArray(r.data) ? r.data : [] })
        .catch(() => { this.parentescos = [] })
    },

    buscar (termo, destino) {
      if (!termo || termo.length < 3) { this[destino] = []; return }
      const flag = destino === 'opcoes' ? 'buscando' : 'buscandoDep'
      this[flag] = true
      this.$axios.post(`${this.base}/leitor/searchByNome`, { query: termo },
                       this.$store.getters.getHeaderAuth)
        .then(r => { this[flag] = false; this[destino] = (r.data && !r.data.erro) ? r.data : [] })
        .catch(() => { this[flag] = false; this[destino] = [] })
    },

    buscarLeitor (t) { this.buscar(t, 'opcoes') },
    buscarDependente (t) { this.buscar(t, 'opcoesDep') },

    carregarFicha () {
      this.ficha = null
      if (!this.tipoId) return
      const q = this.instituicaoAtual ? `?instituicao_id=${this.instituicaoAtual}` : ''
      this.$axios.get(`${this.base}/leitor/ficha/${this.tipoId.tipo}/${this.tipoId.id}${q}`,
                      this.$store.getters.getHeaderAuth)
        .then(r => {
          if (r.data && r.data.erro) {
            return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          }
          this.ficha = r.data
        })
        .catch(e => this.$store.commit('throwException', e))
    },

    vincularDependente () {
      const p = this.novoDep.pessoa.split('-')
      this.$axios.post(`${this.base}/dependente/vincular`, {
        leitor_tipo: this.tipoId.tipo, leitor_id: this.tipoId.id,
        dependente_tipo: p[0], dependente_id: p[1], parentesco: this.novoDep.parentesco
      }, this.$store.getters.getHeaderAuth).then(r => {
        if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
        this.novoDep = { pessoa: '', parentesco: '' }
        window.eventBus.$emit('alert', { msg: 'Dependente vinculado.', type: 'success' })
        this.carregarFicha()
      }).catch(e => this.$store.commit('throwException', e))
    },

    desvincular (d) {
      this.$msgbox.confirm('Desvincular este dependente?', 'Atenção',
        { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          this.$axios.delete(`${this.base}/dependente/desvincular/${d.id}`, this.$store.getters.getHeaderAuth)
            .then(r => {
              if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
              window.eventBus.$emit('alert', { msg: 'Dependente desvinculado.', type: 'success' })
              this.carregarFicha()
            }).catch(e => this.$store.commit('throwException', e))
        }).catch(() => {})
    },

    abrirSuspensao () {
      this.formSusp = { data_inicio: this.$moment().format('YYYY-MM-DD'), data_fim: '', motivo: '' }
      this.dialogSuspender = true
    },

    suspender () {
      if (!this.formSusp.motivo) {
        return window.eventBus.$emit('alert', { msg: 'Informe o motivo da suspensão.', type: 'warning' })
      }
      this.salvando = true
      this.$axios.post(`${this.base}/suspensao/suspender`, Object.assign({}, this.formSusp, {
        leitor_tipo: this.tipoId.tipo, leitor_id: this.tipoId.id,
        instituicao_id: this.instituicaoAtual
      }), this.$store.getters.getHeaderAuth).then(r => {
        this.salvando = false
        if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
        this.dialogSuspender = false
        window.eventBus.$emit('alert', { msg: 'Leitor suspenso.', type: 'success' })
        this.carregarFicha()
      }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
    },

    abrirRevogacao (s) {
      this.suspensaoAlvo = s
      this.formRev = { motivo_revogacao: '' }
      this.dialogRevogar = true
    },

    revogar () {
      if (!this.formRev.motivo_revogacao) {
        return window.eventBus.$emit('alert', { msg: 'Informe o motivo da revogação.', type: 'warning' })
      }
      this.salvando = true
      this.$axios.post(`${this.base}/suspensao/revogar/${this.suspensaoAlvo.id}`, this.formRev,
                       this.$store.getters.getHeaderAuth).then(r => {
        this.salvando = false
        if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
        this.dialogRevogar = false
        window.eventBus.$emit('alert', { msg: 'Suspensão revogada.', type: 'success' })
        this.carregarFicha()
      }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
    }
  }
}
</script>

<style scoped>
.campo { margin-bottom: 14px; }
.campo label { display: block; font-size: 12px; color: #909399; margin-bottom: 2px; }
.campo span { font-size: 14px; color: #303133; }
</style>
